import { useEffect } from 'react';
import {
  Link as ScrollToLink,
  animateScroll
} from "react-scroll";

const Disclaimer = () => {
  useEffect( () => animateScroll.scrollToTop() );

  return (
    <div id="disclaimer-content-wrapper">
      <ScrollToLink />
      <h1 className="major" id="disclaimer">Disclaimer</h1>
      <p>Last updated: April 10, 2018</p>
      <h2>Service Disclaimer</h2>
      <p>The information contained on <a href="http://www.usefulcoin.com" rel="nofollow">http://www.usefulcoin.com</a> website (the “Service”) is for general information purposes only. It is never investment advice.</p>
      <p>Useful Coin LLC assumes no responsibility for errors or omissions in the contents on the Service.</p>
      <p>In no event shall Useful Coin LLC be liable for any special, direct, indirect, consequential, or incidental damages or any damages whatsoever, whether in an action of contract, negligence or other tort, arising out of or in connection with the use of the Service or the contents of the Service. Useful Coin LLC reserves the right to make additions, deletions, or modification to the contents on the Service at any time without prior notice.</p>
      <p>Useful Coin LLC does not warrant that the website is free of viruses or other harmful components.</p>
      <h3>External links disclaimer</h3>
      <p><a href="http://www.usefulcoin.com" rel="nofollow">http://www.usefulcoin.com</a> website may contain links to external websites that are not provided or maintained by or in any way affiliated with Useful Coin LLC.</p>
      <p>Please note that the Useful Coin LLC does not guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.</p>
    </div>
  );
}

export default Disclaimer;
